import React from 'react';
import PropTypes from 'prop-types';

const RatingScaleLabelItem = ({ containerClassName, labelClassName, labelItem, styleLabel }) => {
  return (
    <div className={containerClassName} key={labelItem.id}>
      <div className={labelClassName} style={styleLabel}>
        {labelItem.value}
      </div>
    </div>
  );
};

RatingScaleLabelItem.propTypes = {
  containerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  labelItem: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    value: PropTypes.string,
  }).isRequired,
  styleLabel: PropTypes.object,
};

export default RatingScaleLabelItem;
